import { toast } from "@/hooks/use-toast";
import { useCallback, useEffect, useState } from "react";
import { Button } from "./ui/button";

const VersionWatcher = ({
    interval = 5 * 60 * 1000, // 5 minutes
}: {
    interval?: number;
}) => {
    const [initialIndexFile, setInitialIndexFile] = useState<string>();

    const fetchIndexFile = useCallback(async () => {
        try {
            const title = "A new version is available";
            const toastId = "version-watcher-toast";

            const response = await (
                await fetch("/index.html", {
                    cache: "no-store",
                    headers: {
                        Pragma: "no-cache",
                        "Cache-Control": "no-cache, no-store, must-revalidate",
                    },
                })
            ).text();
            console.log(
                "Version watcher",
                !initialIndexFile
                    ? "Setting intitial value"
                    : response !== initialIndexFile
                      ? "New version available"
                      : "No new version available",
            );

            if (!initialIndexFile) {
                setInitialIndexFile(response);
                return;
            } else if (response !== initialIndexFile) {
                const { dismiss } = toast({
                    title,
                    description: (
                        <div className="gap-default flex flex-col items-start">
                            <span>
                                Please refresh the page to load the latest
                                version of the app.
                            </span>
                            <Button
                                appearance="neutral"
                                onClick={() => window.location.reload()}
                            >
                                Refresh
                            </Button>
                        </div>
                    ),
                    appearance: "warning",
                    duration: interval,
                    id: toastId, // important to keep this, as otherwise it will make a new toast for each check
                });

                setTimeout(() => {
                    // Manually dismiss toast in case user has blurred screen and toast timer stopped ticking
                    dismiss();
                }, interval);
            }
        } catch (error) {
            console.error(error);
            // noop
        }
    }, [initialIndexFile, interval]);

    useEffect(() => {
        if (!initialIndexFile) {
            fetchIndexFile(); // initial fetch
        }
        const intervalID = setInterval(fetchIndexFile, interval);

        return () => clearInterval(intervalID);
    }, [fetchIndexFile, initialIndexFile, interval]);

    return null;
};

export default VersionWatcher;
